import { isDemo } from '@/utils'
import { StoryElement } from '../types'

const STORY: StoryElement[] = [
  {
    type: 'story',
    value:
      "It's the summer of his 20th birthday. Enzo, a lanky, aimless kid from a small town in Italy, spends his days lounging around, helping his mom at the local café, and dreaming of something more—though he doesn't quite know what. University didn't feel right, and he has no clear career in mind. The Italian coastline has always been home, but he's never considered its waves as a call to adventure."
  },
  {
    type: 'story',
    value: 'Then came <strong>the gift</strong>.'
  },
  {
    type: 'story',
    value:
      "On his birthday, Enzo's parents hand him an envelope. Inside is a weekend surf lesson on the Mediterranean coast. They have no idea what they're setting in motion with that simple gesture. Enzo had never even considered surfing; the idea seemed as distant as California's golden beaches."
  },
  {
    type: 'quest',
    value: 'the_surf_lesson'
  },
  {
    type: 'quest',
    value: 'the_first_taste_of_saltwater'
  },
  {
    type: 'story',
    value:
      "Something magical happens that weekend. As soon as his feet touch the sand and he feels the weight of the board under him, something <em>clicks</em> inside. The waves—small and gentle by global standards—roll under him like an invitation. He wipes out more than he stands up, but the stoke is undeniable. By the end of the weekend, he's hooked."
  },
  {
    type: 'story',
    value:
      "Back at his parents' house, Enzo can't think about anything else. Surfing has unlocked a restlessness he's never felt before. But he has no money for a board, no steady job, and certainly no experience. Determined not to let this taste of surfing be his last, Enzo starts working to save up for his first surfboard."
  },
  {
    type: 'story',
    value:
      'Enzo soon finds work as a dishwasher at a nearby café, scrubbing plates and saving money. On weekends, he rents a board and heads out to the local breaks, pushing through wipeouts to practice his popup and whitewater riding.'
  },
  {
    type: 'quest',
    value: 'first_steps_to_independence'
  },
  {
    type: 'story',
    value:
      'As Enzo grows more confident, he begins spending more time at the beach, hoping to earn respect among the locals and learn from the more seasoned surfers. One day, he strikes up a conversation with a group of surfers at the rental shack, who invite him to help out in exchange for lessons on wave reading and paddling techniques. Enzo tries spending every spare moment in the water.'
  },
  {
    type: 'quest',
    value: 'lessons_from_the_locals'
  },
  {
    type: 'story',
    value:
      "With each new wave he catches, Enzo's skills improve, and he feels a sense of belonging in the surf community. Yet, he yearns for bigger challenges. A few weeks later, Marco, his surf instructor, pulls him aside and encourages him to pursue his newfound passion on a larger scale."
  },
  {
    type: 'quest',
    value: 'the_mediterranean_farewell'
  },
  {
    type: 'story',
    value:
      'So, with a beat-up board and a dream, Enzo says goodbye to the familiar shores of the Mediterranean, setting out to chase bigger waves and greater adventures in France.'
  },
  {
    type: 'story',
    value:
      "Enzo has finally saved enough for his own surfboard. The Mediterranean was just the beginning; now, he's ready for something bigger. With his beat-up board strapped to a rented car, he sets out for France, where the waves are rumored to be faster and the surf culture more intense."
  },
  {
    type: 'quest',
    value: 'the_challenge_of_hossegor'
  },
  {
    type: 'story',
    value:
      "Determined to shake off the mocking, Enzo returns to the water daily, though he wipes out as often as he rides. One afternoon, exhausted and low on funds, Enzo reaches Biarritz, a lively surf town buzzing with tourists. Here, he's hit by the financial reality of his new lifestyle."
  },
  {
    type: 'quest',
    value: 'broke_in_biarritz'
  },
  {
    type: 'story',
    value:
      "Working with Sophie allows Enzo to keep surfing while learning about the conditions he needs for success. But just as he starts feeling at home in the waves, Jacques reappears. Though he'd rather avoid Jacques' attitude, Enzo can't help taking the bait when Jacques questions his skills, boasting that Enzo wouldn't last a minute at one of the busier breaks. Enzo, irked, accepts the challenge."
  },
  {
    type: 'quest',
    value: 'rivalry_at_la_graviere'
  },
  {
    type: 'quest',
    value: 'the_journey_continues'
  },
  {
    type: 'story',
    value:
      'With gratitude for his time in France, Enzo sets out for Portugal, looking forward to new challenges, friendships, and his next steps in surfing.'
  }
]
const FULL_GAME_STORY: StoryElement[] = [
  {
    type: 'story',
    value:
      "After months of working odd jobs, scrubbing hostel toilets, and picking up barista shifts, Enzo has finally saved enough to head to <strong>Portugal</strong>. Thierry's stories about the friendly surf towns and affordable living spark a sense of adventure. This new land promises not only better waves but also the chance for Enzo to dive deeper into the art of surfing."
  },
  {
    type: 'quest',
    value: 'peniches_shifting_sands'
  },
  {
    type: 'story',
    value:
      "Enzo is mesmerized by the friendly atmosphere in Portugal and the constant rhythm of the waves. While he's managed to get by with part-time work, he's eager to take his surfing skills to the next level. Soon, he's back in the surf, refining his cutbacks and learning to read the ocean more intuitively. One day, Thiago warns him about Nazaré—a nearby break famous for its intensity—and Enzo feels an irresistible pull to see it for himself."
  },
  {
    type: 'quest',
    value: 'facing_nazares_fury'
  },
  {
    type: 'story',
    value:
      "After surviving his eye-opening session at Nazaré, Enzo's perspective on surfing has shifted. He realizes that skill alone isn't enough—he needs to develop a more profound respect for the ocean's power. During one of his outings, he encounters Sebastião, an enigmatic older surfer who radiates calm and wisdom. Sebastião becomes a mentor, sharing insights that deepen Enzo's connection with the ocean."
  },
  {
    type: 'quest',
    value: 'the_mysterious_traveler'
  },
  {
    type: 'story',
    value:
      "Months pass, and Enzo feels a growing sense of accomplishment and purpose. He's not only improved his surfing but has also saved enough to consider his next big move. Thiago suggests that South Africa could offer him an even greater challenge, and Enzo finds himself at a crossroads, feeling the weight of the decision to leave behind the friends and familiar waves of Portugal."
  },
  {
    type: 'quest',
    value: 'a_leap_of_faith'
  },
  {
    type: 'story',
    value:
      'With gratitude and a renewed sense of purpose, Enzo bids farewell to Portugal, excited to see where his journey will lead him next.'
  },

  // Chapter 4: South Africa's Challenge
  {
    type: 'story',
    value:
      "Enzo arrives in <strong>Cape Town</strong>, following Sebastião's recommendation. The long flight has left him tired but excited. At the airport, he's greeted by Thabo, Sebastião's friend who runs a shark diving business catering to tourists. \"So you're the Italian surfer Sebastião told me about,\" Thabo says with a warm smile. \"I've been looking for someone who can help with our Italian clients. They're a growing market for us.\""
  },
  {
    type: 'quest',
    value: 'teaching_italian_to_shark_diver'
  },
  {
    type: 'story',
    value:
      "Enzo is eager to take his surfing to the next level. The stories of legendary breaks like <strong>Jeffreys Bay</strong> have been calling to him. But this is no vacation—the waves here are unlike anything he's ever faced before. The Atlantic is wilder, the currents stronger, and every session feels like a battle."
  },
  {
    type: 'quest',
    value: 'the_call_of_jeffreys_bay'
  },
  {
    type: 'story',
    value:
      "The power of Jeffreys Bay is both exciting and intimidating. Enzo wipes out constantly but keeps pushing himself to improve. Yet, there's one thing gnawing at him: a deep-seated fear of heavier waves. He's surfed tricky spots before, but <strong>Cape St. Francis</strong> is a different beast. When he finally gathers the courage to paddle out there, the ocean seems to test him harder than ever."
  },
  {
    type: 'quest',
    value: 'conquering_fear'
  },
  {
    type: 'story',
    value:
      "Over the next few weeks, Enzo dedicates himself to improving his fitness and endurance. One day, he meets a group of surfers in <strong>Durban</strong>, who challenge him to something unusual: a long-distance paddle session along the coastline. It's not just about surfing anymore—it's about <strong>fitness</strong>."
  },
  {
    type: 'quest',
    value: 'the_long_paddle_to_durban'
  },
  {
    type: 'story',
    value:
      "With his newfound confidence, Enzo realizes something deeper: South Africa has changed him. The powerful waves, the endurance challenges, and the friendships he's built have transformed him into a more mature surfer. As he sits on the beach after a long session, watching the sunset, he feels an undeniable truth—he's ready for the next chapter. The whispers of <strong>California</strong> have reached his ears."
  },
  {
    type: 'quest',
    value: 'the_soul_of_south_africa'
  },
  {
    type: 'story',
    value:
      'With excitement—and a bit of nervousness—Enzo prepares to leave South Africa behind, knowing the waves of <strong>California</strong> will bring entirely new challenges.'
  },

  // Chapter 5: The Californian Awakening
  {
    type: 'story',
    value:
      "California. The land of golden beaches, endless waves, and a surf culture that's as much about attitude as it is about skill. Enzo steps off the plane, his board under his arm, feeling like he's entering a new world. Unlike the raw, untamed waves of South Africa, California is a place where technique, speed, and style are everything."
  },
  {
    type: 'quest',
    value: 'the_california_dream'
  },
  {
    type: 'story',
    value:
      "At Huntington Beach, the waves roll in mechanically, offering a perfect training ground for refining his technique. But the sheer number of surfers in the lineup makes it difficult to find his place. Back in South Africa, respect was earned through survival—here, it's about proving you belong."
  },
  {
    type: 'story',
    value:
      "As the weeks go by, Enzo begins to get into the rhythm of the Californian surf scene. He starts pushing himself harder, working on his <strong>top turns</strong>. But soon, he realizes that the real challenge isn't just about skill—it's about adaptation."
  },
  {
    type: 'quest',
    value: 'a_cold_reality'
  },
  {
    type: 'story',
    value:
      "At Malibu, Enzo discovers a different approach to surfing. Unlike the aggressive, fast-paced energy of Huntington Beach, Malibu's waves require patience, positioning, and a deeper understanding of <strong>wave reading</strong>. He starts to slow down, to observe, to <strong>flow</strong> rather than fight the ocean."
  },
  {
    type: 'story',
    value:
      "His progress is steady, but California isn't all about finding peace in the waves. It's also where the best surfers in the world sharpen their skills in <strong>competition</strong>. Cody encourages him to enter a local contest at <strong>Huntington Beach</strong>."
  },
  {
    type: 'quest',
    value: 'first_competition_at_huntington'
  },
  {
    type: 'story',
    value:
      "The loss stings, but Enzo knows it's just part of the process. Every great surfer has been humbled at some point, and he takes the defeat as motivation to train harder. He refines his <strong>top turns</strong>, and pushes himself in every session."
  },
  {
    type: 'story',
    value:
      "But as he starts to feel more at home in California's waves, something gnaws at him. The cold water, the crowded breaks—it's not quite the dream he imagined. One night, as he and Cody sit around a beach bonfire, Cody brings up <strong>Australia</strong>."
  },
  {
    type: 'story',
    value:
      '"That\'s where you wanna go next," Cody says. "The Gold Coast, man. Warm water, perfect waves, and some of the best surfers on the planet. That\'s where you really test yourself."'
  },
  {
    type: 'story',
    value: "Enzo doesn't need much convincing. He's ready for the next step."
  },
  {
    type: 'quest',
    value: 'chasing_warmer_waters'
  },
  {
    type: 'story',
    value:
      "With his ticket booked and his sights set on <strong>Australia</strong>, Enzo takes one last look at the California coastline. He's learned a lot here—about skill, about competition, about resilience. But the journey isn't over. If he wants to become a truly great surfer, he has to keep moving forward. The Gold Coast awaits."
  },

  // Chapter 6: Australia East – The Pro Circuit Begins
  {
    type: 'story',
    value:
      "Australia. Warm water, perfect waves, and an entirely new level of surfing culture. Enzo steps off the plane, feeling both excitement and nerves. This isn't just another stop on his journey—it's a proving ground."
  },
  {
    type: 'quest',
    value: 'byron_bays_calm_before_the_storm'
  },
  {
    type: 'story',
    value:
      "After weeks in Byron Bay, Enzo starts feeling restless. The soft, rolling waves have helped him improve his balance, but he craves something more challenging. Running low on funds from his surf shaper apprentice job with Toby, he and Cody hear about <strong>Snapper Rocks</strong>, a break famous for its speed and competition. It's time to push limits."
  },
  {
    type: 'quest',
    value: 'snapper_rocks_fury'
  },
  {
    type: 'story',
    value:
      "With Mick's advice in mind, Enzo trains harder than ever, improving his <strong>speed generation</strong> and <strong>floaters</strong>. After weeks of frustration and breakthroughs, he feels ready for <strong>his first real test</strong>—a contest at <strong>Gold Coast</strong>."
  },
  {
    type: 'quest',
    value: 'battling_through_the_gold_coast'
  },
  {
    type: 'story',
    value:
      "After months of grinding in Australia, Enzo feels the pull of the next horizon. Cody, his longtime travel companion, decides to return home, but Enzo knows his journey isn't over. He's heard whispers about <strong>Indonesia</strong>, a place where waves break over razor-sharp reefs and only the most dedicated surfers thrive."
  },
  {
    type: 'quest',
    value: 'the_warm_australian_goodbye'
  },
  {
    type: 'story',
    value:
      'With his ticket in hand and his skills sharper than ever, Enzo sets out for <strong>Indonesia</strong>, ready to chase his next challenge—<strong>his first barrel</strong>.'
  },

  // Chapter 7: The Indonesian Soul Search
  {
    type: 'story',
    value:
      'Indonesia. The land of warm water, endless waves, and a deep surf culture rooted in respect for the ocean. This is where Enzo will take his next big step—<strong>learning to surf barrels</strong>. But first, he needs to find a way to fund his stay in this surfing paradise.'
  },
  {
    type: 'quest',
    value: 'uluwatus_relentless_waves'
  },
  {
    type: 'story',
    value:
      'Determined to succeed, Enzo balances his time between his diving instructor job and surfing. The income helps fund his surf journey while allowing him to stay close to the ocean. He studies the waves, perfects his <strong>popups</strong> in steep sections, and works towards his first <strong>barrels</strong>. His wave reading skills improve, but the elusive barrel remains just out of reach. The powerful tubes at <strong>Padang Padang</strong> beckon him to try again.'
  },
  {
    type: 'quest',
    value: 'the_frustration_of_padang_padang'
  },
  {
    type: 'story',
    value:
      "The breakthrough at Padang Padang changes everything for Enzo. Finally experiencing the barrel—even briefly—ignites a new passion. Managing the surf and work provides valuable connections. Guests from around the world share stories of legendary waves, and one spot keeps coming up: <strong>the Mentawai Islands</strong>. With his newly discovered barrel skills and growing savings, Enzo knows this is his chance to experience one of surfing's most pristine destinations and truly master the art of <strong>barrel riding</strong>."
  },
  {
    type: 'quest',
    value: 'mentawai_islands_the_first_barrel'
  },
  {
    type: 'story',
    value:
      "With his first true barrel under his belt, Enzo feels like he's finally reached a new level. But even as he celebrates, he knows his journey isn't over. The whispers of <strong>Australia West Coast</strong> and <strong>the pro circuit</strong> are calling. It's time to take the next leap."
  },
  {
    type: 'quest',
    value: 'the_next_horizon'
  },
  {
    type: 'story',
    value:
      "With his ticket booked, Enzo takes one last look at Indonesia's shimmering reefs. His journey to becoming a <strong>true professional surfer</strong> is just beginning. <strong>Australia's west coast and the Qualifying circuit awaits</strong>, bringing new challenges and the chance to test himself against the world's best up-and-coming surfers."
  },

  // Chapter 8: Australia West – The QS Challenge
  {
    type: 'story',
    value:
      "Enzo arrives in <strong>Western Australia</strong>, a land of powerful waves and serious competition. This isn't just another stop — it's his gateway to the <strong>Qualification Series (QS)</strong>, the proving ground for surfers aspiring to reach the Championship Tour. His first step is to test himself at <strong>North Point</strong>, a challenging break known for its powerful, barreling waves."
  },
  {
    type: 'quest',
    value: 'entering_the_qs'
  },
  {
    type: 'story',
    value:
      "The North Point Open is a wake-up call for Enzo. Despite his solid performance, he realizes that today's competitive surfing has evolved beyond powerful turns and barrels. The new generation is taking to the air, performing gravity-defying aerials that judges reward with high scores. If he wants to advance in the QS rankings, he needs to adapt. He hears about Australia's premier <strong>wave pool</strong>, the perfect training ground for <strong>aerial maneuvers</strong>."
  },
  {
    type: 'quest',
    value: 'the_aerial_revolution'
  },
  {
    type: 'story',
    value:
      "With newfound aerial skills in his arsenal, Enzo feels ready to return to the ocean and put them to the test. The <strong>Margaret River Pro</strong> offers the perfect opportunity—a QS event that attracts top talent from around the world. Here, he'll need to combine everything he's learned: powerful turns, barrel riding, and now, his emerging aerial game. The stakes are higher than ever as he fights for the QS points that could secure his path to the Championship Tour."
  },
  {
    type: 'quest',
    value: 'margaret_river_qualification'
  },
  {
    type: 'story',
    value:
      "Enzo's performance at Margaret River changes everything. Sponsors take notice, fans remember his name, and his QS ranking jumps dramatically. With each competition, his confidence grows and his technique diversifies. He's no longer just a traveling surfer—he's becoming a <strong>legitimate professional</strong> with a shot at <strong>qualifying for the Championship Tour</strong>. But before he can secure his spot, there's one final challenge that awaits all aspiring pros: <strong>Hawaii</strong>."
  },
  {
    type: 'quest',
    value: 'breakthrough_in_the_west'
  },
  {
    type: 'story',
    value:
      "With his <strong>qualification almost secured</strong>, Enzo sets his sights on <strong>Hawaii</strong>—the ultimate proving ground. The world's best surfers. The heaviest waves. The most prestigious contests. <strong>Pipeline</strong> awaits, where legacies are made and courage is tested like nowhere else. This is where Enzo will face the biggest challenge of his surfing life."
  },

  // Chapter 9: Hawaii – The Ultimate Proving Ground
  {
    type: 'story',
    value:
      "Enzo steps onto the sands of <strong>Hawaii</strong>, the beating heart of surfing culture. His eyes are immediately drawn to <strong>Pipeline</strong>, the mythical wave he's seen in countless videos and magazines. Standing on the beach, watching perfect barrels thunder over the reef, the reality hits him harder than any wave he's faced before. This isn't just another challenge; it's surfing's ultimate proving ground."
  },
  {
    type: 'quest',
    value: 'the_pipeline_proving_ground'
  },
  {
    type: 'story',
    value:
      "The injury from Pipeline becomes Enzo's first true Hawaiian lesson. As he recovers, watching the waves from shore, he absorbs everything - the timing of sets, the positioning of local surfers, the subtle reef channels. What initially seemed like a setback transforms into a period of profound learning. With newfound humility and respect, he sets his sights on <strong>Honolua Bay</strong>, a wave that will test his technical skills rather than just his courage."
  },
  {
    type: 'quest',
    value: 'the_honolua_showdown'
  },
  {
    type: 'story',
    value:
      "Success at Honolua elevates Enzo's status in Hawaii. No longer viewed as just another visiting surfer, he's earned genuine respect. This newfound recognition opens the door to <strong>Waimea Bay</strong>, where the true giants of Hawaiian surfing test themselves. With big winter swells rolling in, the WSA Qualifier at Waimea represents both terrifying risk and incredible opportunity."
  },
  {
    type: 'quest',
    value: 'waimea_bay_big_wave_dreams'
  },
  {
    type: 'story',
    value:
      "Making the semifinals at Waimea changes everything. Sponsors call, media attention grows, and suddenly Enzo finds himself on the verge of competing for the World Title. But deep down, he knows that the final test awaits back where his Hawaiian journey began - Pipeline. In the weeks leading up to the championship, Enzo transforms his approach. He trains at dawn like never before, studies every nuance of Pipeline's reef, meditates on the beach to center his mind, and even consults Hawaiian elders about the spiritual connection to the wave. His preparation becomes legendary among locals - the Italian who treats Pipeline with the reverence it deserves."
  },
  {
    type: 'quest',
    value: 'world_title_at_pipeline'
  },
  {
    type: 'story',
    value:
      "As the confetti settles and Enzo clutches the World Title trophy, surrounded by cheering fans and fellow competitors, he experiences a moment of profound clarity. This achievement, unimaginable when he first paddled out in the Mediterranean, isn't the end of his journey. The call of <strong>Tahiti</strong> and its mythical wave <strong>Teahupo'o</strong> whispers in his mind. To truly become the greatest, there remains one final frontier to conquer."
  },

  // Chapter 10: Tahiti – The Grand Finale
  {
    type: 'story',
    value:
      "Months after his World Title victory, Enzo arrives in <strong>Tahiti</strong> with little fanfare, slipping quietly into the island's rhythm. Despite his championship status, he approaches <strong>Teahupo'o</strong> - arguably the heaviest wave on the planet - with humility. This isn't about trophies or recognition anymore; it's about understanding the ultimate wave and discovering his final evolution as a surfer."
  },
  {
    type: 'quest',
    value: 'training_for_teahupo_o'
  },
  {
    type: 'story',
    value:
      "Learning Teahupo'o's secrets changes Enzo's perspective on surfing. The raw power, the precise reef mapping, the cultural significance to Tahitians - it all deepens his connection to the sport in ways trophies never could. To prepare for the ultimate test, he spends time at <strong>Papara</strong>, refining his technique and integrating himself into local Tahitian life."
  },
  {
    type: 'quest',
    value: 'the_papara_warm_up'
  },
  {
    type: 'story',
    value:
      "The whispers begin among locals first - this World Champion isn't like others they've seen. His respect for their waves and culture, his dedication to understanding rather than conquering Teahupo'o, marks him as different. Word spreads through the global surf community that Enzo is preparing for something special. When the Teahupo'o Championships are announced, coinciding with a historic swell, the stage is set for what could be the defining moment in modern surfing."
  },
  {
    type: 'quest',
    value: 'olympic_gold_at_teahupo_o'
  },
  {
    type: 'story',
    value:
      "As Enzo stands atop the podium at Teahupo'o, having surfed what veterans are already calling 'the barrel of the century,' he reflects on the journey that transformed him from a clueless Italian kid to the <strong>Greatest Of All Time</strong>. The title isn't just about his performances but about the way he's connected with each wave, each culture, each challenge along the way."
  },
  {
    type: 'story',
    value:
      "In interviews after his historic win, journalists ask what's next. Enzo smiles and speaks of returning to his roots - to teach kids in the Mediterranean, to share the wisdom of the ocean with the next generation. For while records and titles may eventually fall, the <strong>true legacy of a G.O.A.T.</strong> is measured by what they give back to the sport that gave them everything."
  }
]
const DEMO_END_STORY: StoryElement[] = [
  {
    type: 'story',
    value:
      'Thank you for playing the demo of the GOAT Surfer! You can purchase and activate the full game in Settings to continue the story. Join the Discord to brag about your surf skill progress and to be first to know about the next updates: <a href="https://discord.gg/VzEeEycYHa" target="_blank" rel="noopener noreferrer"><img src="/assets/discord.svg" alt="Discord" style="height: 40px;" /></a>'
  }
]
const TEMPORARY_END_STORY: StoryElement[] = [
  {
    type: 'story',
    value:
      'This is temporary end of the story. The game is in development, and more content is coming soon. Join the Discord to brag about your surf skill progress and to be first to know about the next updates: <a href="https://discord.gg/VzEeEycYHa" target="_blank" rel="noopener noreferrer"><img src="/assets/discord.svg" alt="Discord" style="height: 40px;" /></a>'
  }
]
const FULL_GAME_END_STORY: StoryElement[] = [
  {
    type: 'story',
    value:
      'Thank you for playing, and congratulations on becoming the <strong>GOAT Surfer</strong>! Join the Discord to brag about your surf skill progress and to connect with other GOAT surfers!: <a href="https://discord.gg/VzEeEycYHa" target="_blank" rel="noopener noreferrer"><img src="/assets/discord.svg" alt="Discord" style="height: 40px;" /></a>'
  }
]

export function getStory(): StoryElement[] {
  if (isDemo()) {
    return [...STORY, ...DEMO_END_STORY]
  }
  return [...STORY, ...FULL_GAME_STORY, ...FULL_GAME_END_STORY]
}
